import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Divider,
  FieldsContainer,
  FieldsSection,
  FlexContainer,
} from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import Back from "sushiweb/Icons/all/Back";
import Upload from "sushiweb/Icons/all/Upload";
import Breadcrumb from "sushiweb/Breadcrumb";
import variables from "../../constants/assets/variables";
import Button from "sushiweb/Button";
import { getInitialState, isMobile, isValNull } from "../../utils";
import fieldsState from "./fieldsState.json";
import Textarea from "sushiweb/InputTypes/Textarea";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import DateTimePicker from "../../components/Common/DateTimePicker";
import ReleaseLaunchDetails from "../../components/DriverAppReleases/ReleaseLaunchDetails";
import FileUpload from "../../components/Common/FileUpload";
import LaunchReleaseModal from "../../components/DriverAppReleases/LaunchReleaseModal";
import {
  getActiveAppRelease,
  resetState,
  updateAppRelease,
  createAppRelease,
  downloadAppApks,
  uploadAppApks,
} from "../../store/actions/DriverAppReleases";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import DownloadBar from "../../components/Common/DownloadBar";
import MultiFileUpload from "../../components/Common/MultiFileUpload";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../../components/Common/Permission";
import ConfirmationModal from "../../components/Common/ConfirmationModal";
import { handleValidations } from "./utils";
import ErrorModal from "../../components/Common/ErrorModal";
import SpinLoader from "../../components/Common/SpinLoader";
import { getDriverReleasedList } from "../../store/actions/DriverReleasedVersion";
import InfiniteScrollDropdown from "../../components/Common/InfiniteScrollDropdown";

const ReleaseTypes = ["SOFT", "HARD"];

const getJoinedFileName = (files) => {
  return (
    files.length > 0 &&
    files.reduce((acc, file) => acc + file.name + ",", "").slice(0, -1)
  );
};

const DriverAppReleasesActions = ({
  activeAppRelease,
  getActiveAppRelease,
  resetState,
  createAppRelease,
  updateAppRelease,
  downloadAppApks,
  uploadAppApks,
}) => {
  const location = useLocation();
  const [activeFiles, setActiveFiles] = useState("");
  const history = useHistory();
  const searchQueryParams = location.search;
  const paramsObject = new URLSearchParams(searchQueryParams); //type,version,id of appRelease
  const actionType = paramsObject.get("type");
  const appReleaseId = paramsObject.get("id");
  const appReleaseVersion = paramsObject.get("version");
  const [launchNow, setLaunchNow] = useState(false);
  const [initialState, setInitialState] = useState(fieldsState);
  const [launchModal, showLaunchModal] = useState(false);
  const [callbackKey, setCallbackKey] = useState("");
  const [presignUrls, setPresignUrls] = useState({});
  const [creationId, setCreationId] = useState("");
  const [creationVersion, setCreationVersion] = useState("");
  const [activeFEIdFile, setActiveFEIdFile] = useState("");
  const [launchState, setLaunchState] = useState({
    city_ids: [],
    locality_ids: [],
    categories: [],
  });
  const [stableConfirmationModal, setStableConfirmationModal] = useState(false);
  const [formErrors, setFormErrors] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [loader, showLoader] = useState(false);
  const allActions = MenuActionsMappings[MenuNames.DRIVER_APP_RELEASE];

  const handleBackClick = () => {
    history.push("/driver-app-releases");
  };

  const handleChange = (key, val) => {
    if (
      key === "stable" &&
      actionType === "edit" &&
      Object.keys(activeAppRelease).length > 0 &&
      activeAppRelease["stable"]
    ) {
      return;
    } else if (key == "stable" && !initialState.stable) {
      setStableConfirmationModal(true);
      return;
    }
    const values = { ...initialState };
    values[key] = val;
    if (key === "release_type") {
      if (val === "HARD") {
        values["soft_launch_max_attempts"] = "";
        values["soft_launch_valid_till"] = "";
      }
    }
    setInitialState(values);
  };

  const handleStableChangeCancel = () => {
    setStableConfirmationModal(false);
  };

  const markReleaseStable = () => {
    const values = { ...initialState };
    values["stable"] = true;
    setInitialState(values);
    setStableConfirmationModal(false);
  };

  const removeApkFiles = () => {
    setActiveFiles([]);
  };

  const handleFileChange = (files) => {
    setActiveFiles(files);
  };

  const handleLaunchRelease = (val) => {
    setLaunchNow(val);
  };

  const handleButtonClick = (name) => {
    let payload = { ...initialState };
    if (payload["soft_launch_valid_till"]) {
      const date = new Date(payload["soft_launch_valid_till"]);
      payload["soft_launch_valid_till"] = date.toISOString();
    }
    if (!isValNull(payload["soft_launch_max_attempts"])) {
      payload["soft_launch_max_attempts"] = Number(
        payload["soft_launch_max_attempts"]
      );
    }
    if (payload["release_type"] === "HARD") {
      delete payload["soft_launch_max_attempts"];
      delete payload["soft_launch_valid_till"];
    }
    if (name === "launch") {
      showLaunchModal(true);
    } else if (name === "edit") {
      history.push(
        `/driver-app-releases/actions?type=edit&id=${appReleaseId}&version=${appReleaseVersion}`
      );
    } else if (name === "cancel") {
      if (actionType === "edit") {
        history.push(
          `/driver-app-releases/actions?type=view&id=${appReleaseId}&version=${appReleaseVersion}`
        );
      } else {
        history.push("/driver-app-releases");
      }
    } else if (name === "save") {
      //handle validations here
      const validationErrors = handleValidations({
        initialState: payload,
        launch_now: launchNow,
        activeFEIdFile: activeFEIdFile,
        launchState: launchState,
        activeFiles: activeFiles,
        actionType: actionType,
      });
      if (validationErrors.length > 0) {
        setFormErrors(validationErrors);
        setErrorModal(true);
        return;
      }
      if (actionType === "edit") {
        if (showApksUploadOption() && activeFiles) {
          const filename = getJoinedFileName(activeFiles);
          showLoader(true);
          uploadAppApks(filename)
            .then((res) => {
              setCallbackKey(res.callback_key);
              setPresignUrls(res.upload_urls);
            })
            .catch((_) => showLoader(false));
        } else {
          showLoader(true);
          updateAppRelease(payload).then((_) => {
            showLoader(false);
          });
        }
      } else if (actionType == "create") {
        const filename = getJoinedFileName(activeFiles);
        if (!filename) {
          handleUploadSuccessApks();
          return;
        }
        showLoader(true);
        uploadAppApks(filename)
          .then((res) => {
            showLoader(false);
            setCallbackKey(res.callback_key);
            setPresignUrls(res.upload_urls);
          })
          .catch((_) => showLoader(false));
      }
    }
  };

  const handleUploadSuccessApks = () => {
    //on successful uploading of apk files
    const payload = { ...initialState };
    if (payload["soft_launch_valid_till"]) {
      const date = new Date(payload["soft_launch_valid_till"]);
      payload["soft_launch_valid_till"] = date.toISOString();
    }
    if (!isValNull(payload["soft_launch_max_attempts"])) {
      payload["soft_launch_max_attempts"] = Number(
        payload["soft_launch_max_attempts"]
      );
    }
    if (payload["release_type"] === "HARD") {
      delete payload["soft_launch_max_attempts"];
      delete payload["soft_launch_valid_till"];
    }
    if (actionType === "edit") {
      updateAppRelease(payload).then((_) => {
        showLoader(false);
      });
    } else {
      createAppRelease(payload).then((res) => {
        //read creation id
        showLoader(false);
        if (launchNow) {
          setCreationId(res.id);
          setCreationVersion(res.version);
        } else {
          history.push(
            `/driver-app-releases/actions?type=edit&id=${res.id}&version=${res.version}`
          );
        }
      });
    }
  };

  const handleLaunchModalClose = () => {
    showLaunchModal(false);
  };

  const BreadCrumbBar = () => {
    return (
      <>
        <Back
          onClick={handleBackClick}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link onClick={handleBackClick}>
            Driver app releases
          </Breadcrumb.Link>
          {actionType === "create" ? (
            <Breadcrumb.Link>create new release</Breadcrumb.Link>
          ) : (
            <React.Fragment>
              <Breadcrumb.Link>{appReleaseVersion}</Breadcrumb.Link>
              <Breadcrumb.Link>{actionType}</Breadcrumb.Link>
            </React.Fragment>
          )}
        </Breadcrumb>
      </>
    );
  };

  const RightActionButtons = () => {
    return actionType === "view" ? (
      <>
        <Permission requiredPerms={[allActions.UPDATE]}>
          <Button
            data-testid="editAppReleaseBtn"
            onClick={() => handleButtonClick("edit")}
            className="sushi-btn mr-20"
            appearance="outline"
          >
            Edit
          </Button>
        </Permission>
        <Permission requiredPerms={[allActions.LAUNCH]}>
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={() => handleButtonClick("launch")}
            className="sushi-btn"
          >
            Launch
          </Button>
        </Permission>
      </>
    ) : (
      <>
        <Button
          data-testid="saveAppReleaseBtn"
          className="sushi-btn mr-20"
          onClick={() => handleButtonClick("save")}
        >
          Save
        </Button>
        <Button
          data-testid="cancelAppReleaseBtn"
          onClick={() => handleButtonClick("cancel")}
          className="sushi-btn"
          appearance="outline"
        >
          Cancel
        </Button>
      </>
    );
  };

  const downloadApkFiles = () => {
    downloadAppApks(appReleaseId).then((res) => {
      res !== undefined && window.open(res.download_url);
    });
  };

  const checkDisabledField = (key) => {
    if (key === "version") {
      return actionType !== "create";
    }
    return actionType === "view";
  };

  const showApksUploadOption = () => {
    if (actionType === "edit") {
      if (activeAppRelease.expected_rider_count === 0) {
        return true;
      }
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (
      !isValNull(appReleaseId) &&
      isValNull(creationId) &&
      (isValNull(activeAppRelease.id) || appReleaseId != activeAppRelease.id)
    ) {
      getActiveAppRelease(appReleaseId);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(activeAppRelease).length > 0 && actionType !== "create") {
      const values = { ...initialState };
      Object.keys(values).forEach((key) => {
        if (!isValNull(activeAppRelease[key])) {
          values[key] = activeAppRelease[key];
        } else {
          values[key] = getInitialState(initialState, key);
        }
      });
      if (values["soft_launch_valid_till"]) {
        values["soft_launch_valid_till"] = moment(
          values["soft_launch_valid_till"]
        ).format("YYYY-MM-DDTHH:mm");
      }
      setInitialState(values);
    }
  }, [activeAppRelease]);

  return [
    <AppReleasesActionsView>
      <FlexContainer>
        <LeftContainer justify="flex-start">{BreadCrumbBar()}</LeftContainer>
        <RightContainer flexpct="25">{RightActionButtons()}</RightContainer>
      </FlexContainer>
      <FieldsContainer border noPadding className="mt-40">
        <FieldsHolder>
          <FieldsSection marginBottom="1.75rem">
            <p className="section-heading">BASIC DETAILS</p>
            <Input
              value={initialState.version}
              data-testid="appVersionField"
              id="sushi-input"
              onChange={(e) => handleChange("version", e)}
              disabled={checkDisabledField("version")}
              label="Version"
              innerWidth="20%"
            />
            {actionType !== "create" && (
              <FlexContainer justify="flex-start">
                <Input
                  value={activeAppRelease.current_rider_count}
                  data-testid="appReleaseCurrentRiderCount"
                  id="sushi-input"
                  label="Current rider count"
                  disabled={true}
                />
                <Input
                  value={activeAppRelease.expected_rider_count}
                  data-testid="appReleaseCurrentRiderCount"
                  id="sushi-input"
                  label="Expected rider count"
                  disabled={true}
                />
              </FlexContainer>
            )}
            <Textarea
              id="sushi-textarea"
              borderColor={variables.primaryColor}
              innerWidth="80%"
              resize="none"
              label="Release notes"
              data-testid="versionReleaseNotes"
              onChange={(e) => handleChange("release_notes", e)}
              disabled={checkDisabledField("release_notes")}
              value={initialState.release_notes}
            />
            <FlexContainer className="mt-30" justify="flex-start">
              {actionType !== "create" && (
                <Checkbox
                  value="stable"
                  color={variables.red500}
                  checked={initialState.stable}
                  onChange={(e) => handleChange("stable", e.stable)}
                  disabled={checkDisabledField("stable")}
                  className="sushi-checkbox mr-40"
                  label="Stable"
                />
              )}
              <Checkbox
                value="show_on_driver_edit"
                color={variables.red500}
                checked={initialState.show_on_driver_edit}
                onChange={(e) =>
                  handleChange("show_on_driver_edit", e.show_on_driver_edit)
                }
                disabled={checkDisabledField("show_on_driver_edit")}
                className="sushi-checkbox"
                label="Show on driver edit"
              />
            </FlexContainer>
          </FieldsSection>
        </FieldsHolder>
        <Divider height="6px" color={variables.grey100} />
        <FieldsHolder>
          <FieldsSection marginBottom="1.75rem">
            <p className="section-heading">LAUNCH DETAILS</p>
            <InfiniteScrollDropdown
              id="releasedApp_dropdown"
              multiple
              priorityFlag={true}
              appliedFilters={{}}
              getActiveList={getDriverReleasedList}
              resKey="releasedAppVersions"
              modalState={"Edit"}
              keyName="exclude_versions"
              labelKey="name"
              keyTypeToSet="name"
              label="Exclude app versions"
              handleChange={handleChange}
            />
            <PaginatedReactDropdown
              options={ReleaseTypes}
              handleChange={handleChange}
              keyToChange="release_type"
              placeholder="Release type"
              disabled={checkDisabledField("release_type")}
              showCross={true}
              id="appReleaseTypeField"
              width="20%"
              value={initialState.release_type}
            />
            <DateTimePicker
              value={initialState.soft_launch_valid_till}
              placeholder="Soft launch valid till"
              handleChange={(e) => {
                console.log("e", e);
                return handleChange("soft_launch_valid_till", e.target.value);
              }}
              disabled={checkDisabledField("soft_launch_valid_till")}
              id="softLaunchValidTillField"
            />
            <Input
              value={initialState.soft_launch_max_attempts}
              data-testid="softLaunchMaxAttemptsField"
              id="sushi-input"
              type="number"
              onChange={(e) => handleChange("soft_launch_max_attempts", e)}
              label="Soft launch max attempts"
              disabled={checkDisabledField("soft_launch_max_attempts")}
              innerWidth="40%"
            />
            {actionType === "view" ? (
              <DownloadBar
                title="Download apk files"
                handleDownload={downloadApkFiles}
              />
            ) : (
              <>
                {showApksUploadOption() && (
                  <MultiFileUpload
                    heading="Upload release apks"
                    uploadUrl="/driver-app-releases/bulk/upload-apks/ack"
                    callback_key={callbackKey}
                    presign_urls={presignUrls}
                    activeFiles={activeFiles}
                    keyName="callback_key"
                    acceptTypes=".apk"
                    setActiveFiles={handleFileChange}
                    handleFileUploadSuccess={handleUploadSuccessApks}
                    UploadIcon={<Upload color={variables.black} />}
                  />
                )}
                {showApksUploadOption() && activeFiles.length > 0 && (
                  <div
                    onClick={removeApkFiles}
                    className="download-link mb-30 mt-20"
                  >
                    Remove selected apk files
                  </div>
                )}
                {actionType === "edit" && (
                  <div
                    onClick={downloadApkFiles}
                    className="download-link mt-20"
                  >
                    Download current apk files
                  </div>
                )}
              </>
            )}
            {actionType === "create" && (
              <div className="launch-now mt-30">
                <Checkbox
                  value="launchNow"
                  color={variables.red500}
                  checked={launchNow}
                  onChange={(e) => handleLaunchRelease(e.launchNow)}
                  className="sushi-checkbox mr-40"
                  label="Launch now"
                />
                {launchNow && (
                  <ReleaseLaunchDetails
                    appReleaseId={creationId}
                    appReleaseVersion={creationVersion}
                    setCreationId={setCreationId}
                    setCreationVersion={setCreationVersion}
                    launchState={launchState}
                    setLaunchState={setLaunchState}
                    activeFile={activeFEIdFile}
                    setActiveFile={setActiveFEIdFile}
                  />
                )}
              </div>
            )}
          </FieldsSection>
        </FieldsHolder>
      </FieldsContainer>
      {launchModal && (
        <LaunchReleaseModal
          appVersion={appReleaseVersion}
          appReleaseId={appReleaseId}
          handleModalClose={handleLaunchModalClose}
          activeAppRelease={activeAppRelease}
        />
      )}
      {errorModal && (
        <ErrorModal
          handleSubmit={() => setErrorModal(false)}
          errors={formErrors}
        />
      )}
      {loader && <SpinLoader />}
    </AppReleasesActionsView>,
    <ConfirmationModal
      open={stableConfirmationModal}
      modalTitle="Are you sure?"
      onCofirmCancelHandler={handleStableChangeCancel}
      onCofirmSuccessHandler={markReleaseStable}
      successButtonText="Yes"
      cancelButtonText="No"
      successButtonColor="secondary"
    >
      Are you sure to mark release stable?
    </ConfirmationModal>,
  ];
};

const AppReleasesActionsView = styled.section`
  .file-upload-box {
    label {
      border: 1px solid ${variables.primaryColor};
      padding: 20px;
      border-radius: 8px;
      max-width: unset;
      width: 40%;
    }
  }
  .modal-content {
    .file-upload-box label {
      width: 60%;
    }
  }
  .download-link {
    color: ${variables.blue500};
    font-size: 0.875rem !important;
    cursor: pointer;
    text-decoration: underline;
  }
`;

const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;

const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  justify-content: flex-end;
  .actionDropdown {
    width: 100%;
    margin-bottom: unset;
  }
`;

const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

function mapStateToProps(state) {
  const { DriverAppReleases } = state;
  return {
    activeAppRelease: DriverAppReleases.activeAppRelease,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActiveAppRelease: bindActionCreators(getActiveAppRelease, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
    updateAppRelease: bindActionCreators(updateAppRelease, dispatch),
    createAppRelease: bindActionCreators(createAppRelease, dispatch),
    downloadAppApks: bindActionCreators(downloadAppApks, dispatch),
    uploadAppApks: bindActionCreators(uploadAppApks, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverAppReleasesActions);
